import ReactSelect from "../ReactSelect/ReactSelect2";

import { getImageUrl } from "Common/utils/ImageDomain";

const TwoColumnScrollSegmentCard = ({
  isEditable,
  index,
  singleColumnData,
  onecolumnContent,
  twocolumnContent,
  removeSegment,
  handleRemoveOneColumnImage,
  handleRemoveTwoColumnImage,
  setIndexBack,
  setEventData,
  setIndex,
  setImageUrl,
  contentType,
  toggle,
  handleSegmentInputChange,
  errors,
}) => {
  return (
    <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
      <label className="inline-block mb-2 text-base font-medium">
        cardLabel
      </label>
      <input
        disabled={!isEditable}
        type="text"
        value={singleColumnData["header_text"]}
        onChange={(e) =>
          handleSegmentInputChange(index, "header_text", e.target.value)
        }
        className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        placeholder="Enter header text"
      />
      {errors.segments[index]?.header_text && (
        <p className="text-sm text-red-500">
          {errors.segments[index].header_text}
        </p>
      )}

      <label className="inline-block mb-2 text-base font-medium">
        Column One Content Type
      </label>

      <ReactSelect
        options={contentType}
        index={index}
        contentType={onecolumnContent}
        handleContentChange={handleSegmentInputChange}
        name={"column_one_content_type"}
        id={`content-type14${index}`}
        isMulti={false}
        placeholder={"Select content type"}
      />
      {errors.segments[index]?.column_one_content_type && (
        <p className="text-sm text-red-500">
          {errors.segments[index].column_one_content_type}
        </p>
      )}
      {onecolumnContent?.value === contentType[2]?.value && (
        <div className="flex mt-4 mb-2">
          {singleColumnData?.column_one_image_url ? (
            <div className="flex items-center">
              <div className="relative w-40 h-40">
                <img
                  data-dz-thumbnail
                  className="rounded border-[gray] border"
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                  }}
                  src={getImageUrl(singleColumnData?.column_one_image_url)}
                  alt={"img"}
                />
                <span
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "6px",
                    fontSize: "22px",
                    cursor: "pointer",
                  }}
                  onClick={
                    isEditable
                      ? () => {
                          handleRemoveOneColumnImage(index);
                        }
                      : null
                  }
                >
                  ×
                </span>
              </div>
              <div className="h-3 ml-3">
                <button
                  onClick={
                    isEditable
                      ? () => {
                          toggle();
                          setIndex(index);
                          setIndexBack(undefined);
                          setEventData(undefined);
                          setImageUrl("column_one_image_url");
                        }
                      : null
                  }
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  Change
                </button>
              </div>
            </div>
          ) : (
            <button
              onClick={
                isEditable
                  ? () => {
                      toggle();
                      setIndex(index);
                      setIndexBack(undefined);
                      setEventData(undefined);
                      setImageUrl("column_one_image_url");
                    }
                  : null
              }
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Add imageUrl
            </button>
          )}
        </div>
      )}
      {onecolumnContent?.value === contentType[1]?.value && (
        <div>
          <label className="inline-block mb-2 text-base font-medium">
            Column One Text
          </label>
          <textarea
            disabled={!isEditable}
            data-type="text"
            value={singleColumnData.column_one_text}
            rows={4}
            onChange={
              isEditable
                ? (e) =>
                    handleSegmentInputChange(
                      index,
                      "column_one_text",
                      e.target.value
                    )
                : null
            }
            className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
            placeholder="Enter column one text"
          />
        </div>
      )}
      <label className="inline-block mb-2 text-base font-medium">
        Column Two Content Type
      </label>

      <ReactSelect
        index={index}
        options={contentType}
        contentType={twocolumnContent}
        handleContentChange={handleSegmentInputChange}
        name={"column_two_content_type"}
        id={`content-type2${index}`}
        isMulti={false}
        placeholder={"Select content type"}
      />
      {errors.segments[index]?.column_two_content_type && (
        <p className="text-sm text-red-500">
          {errors.segments[index].column_two_content_type}
        </p>
      )}
      {twocolumnContent?.value === contentType[2]?.value && (
        <div className="flex mt-4 mb-2">
          {singleColumnData?.column_two_image_url ? (
            <div className="flex items-center">
              <div className="relative w-40 h-40 ">
                <img
                  data-dz-thumbnail
                  className="rounded border-[gray] border"
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                  }}
                  src={getImageUrl(singleColumnData?.column_two_image_url)}
                  alt={"img"}
                />
                <span
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "6px",
                    fontSize: "22px",
                    cursor: "pointer",
                  }}
                  onClick={
                    isEditable
                      ? () => {
                          handleRemoveTwoColumnImage(index);
                        }
                      : null
                  }
                >
                  ×
                </span>
              </div>
              <div className="h-3 ml-3">
                <button
                  onClick={
                    isEditable
                      ? () => {
                          toggle();
                          setIndex(index);
                          setIndexBack(undefined);
                          setEventData(undefined);
                          setImageUrl("column_two_image_url");
                        }
                      : null
                  }
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  Change
                </button>
              </div>
            </div>
          ) : (
            <button
              onClick={
                isEditable
                  ? () => {
                      toggle();
                      setIndex(index);
                      setIndexBack(undefined);
                      setEventData(undefined);
                      setImageUrl("column_two_image_url");
                    }
                  : null
              }
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Add imageUrl
            </button>
          )}
        </div>
      )}
      {twocolumnContent?.value === contentType[1]?.value && (
        <div>
          <label className="inline-block mb-2 text-base font-medium">
            Column Two Text
          </label>
          <textarea
            disabled={!isEditable}
            data-type="text"
            value={singleColumnData.column_two_text}
            rows={4}
            onChange={(e) =>
              handleSegmentInputChange(index, "column_two_text", e.target.value)
            }
            className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
            placeholder="Enter column two text"
          />
        </div>
      )}
      {/* Remove Segment Button */}
      <div className="flex justify-end mt-2">
        <button
          onClick={isEditable ? () => removeSegment(index) : null}
          className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
        >
          Remove
        </button>
      </div>
    </div>
  );
};

export default TwoColumnScrollSegmentCard;
